import React from "react";
import * as PropTypes from "prop-types";
import { parseNullableAlphaCell, parseIntegerCell, parseNumericCell } from "../../utilities";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-material.css";
import { withTranslation } from "react-i18next";
import { translateGridText } from "../../i18n";
import BooleanCellRenderer from "../BooleanCellRenderer";
import { maximumYear, minimumYear } from "../../constants";

const columnDefinitions = (t) => [
    {
        headerName: t("Region code"),
        field: "regionCode",
        width: 150,
        headerClass: "ag-left-aligned-header",
        valueParser: (params) => parseNullableAlphaCell(params),
    },
    {
        headerName: t("In union?"),
        field: "isInUnion",
        width: 125,
        headerClass: "ag-left-aligned-header",
        cellStyle: { textAlign: "center" },
        cellRenderer: "booleanCellRenderer",
        cellEditor: "agRichSelectCellEditor",
        cellEditorParams: {
            cellRenderer: "booleanCellRenderer",
            values: [true, false],
        },
        cellEditorPopup: true,
    },
    {
        headerName: t("Age"),
        field: "ageRange",
        width: 125,
        headerClass: "ag-left-aligned-header",
        cellStyle: { textAlign: "center" },
        cellEditor: "agRichSelectCellEditor",
        cellEditorParams: {
            values: ["10-14", "15-19", "20-24", "25-29", "30-34", "35-39", "40-44", "45-49", "15-49"],
        },
        cellEditorPopup: true,
    },
    {
        headerName: t("Year"),
        field: "midYear",
        type: "numericColumn",
        filter: "agNumberColumnFilter",
        width: 125,
        headerClass: "ag-left-aligned-header",
        valueParser: (params) => parseIntegerCell(params, minimumYear, maximumYear),
    },
    {
        headerName: t("Population"),
        field: "population",
        type: "numericColumn",
        filter: "agNumberColumnFilter",
        width: 200,
        headerClass: "ag-left-aligned-header",
        valueParser: (params) => parseNumericCell(params, 0, 9999999999),
    },
];

const PrepareDataPopulationDataTable = ({ t, ...rest }) => {
    const onGridReady = (params) => {
        rest.onGridReady(params);
        params.columnApi.autoSizeAllColumns();
    };

    const onSelectionChanged = () => {
        rest.onSelectedChanged();
    };

    const components = React.useMemo(
        () => ({
            booleanCellRenderer: BooleanCellRenderer,
        }),
        []
    );

    const rowData = rest.data;
    const columnDefs = columnDefinitions(t);

    return (
        <div className="ag-theme-material">
            <AgGridReact
                domLayout="autoHeight"
                defaultColDef={{ sortable: true, editable: true }}
                pagination={true}
                paginationPageSize={10}
                suppressColumnVirtualisation={true}
                suppressCellFocus={true}
                components={components}
                overlayNoRowsTemplate="<span />"
                getLocaleText={translateGridText}
                rowData={rowData}
                columnDefs={columnDefs}
                onGridReady={onGridReady}
                rowSelection="single"
                onSelectionChanged={onSelectionChanged}
                stopEditingWhenCellsLoseFocus={true}
                rowHeight={30}
            />
        </div>
    );
};

PrepareDataPopulationDataTable.propTypes = {
    data: PropTypes.array,
};

PrepareDataPopulationDataTable.defaultProps = {
    data: [],
};

export default withTranslation()(PrepareDataPopulationDataTable);
